import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <section className="py-12 px-4 bg-matrix-surface border-y border-matrix-dim" data-id="element-105">
      <div className="max-w-5xl mx-auto" data-id="element-106">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-matrix-orange mb-10 text-center" data-id="element-107">
          Para quién es (y para quién no)
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-108">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-109">
            <h3 className="text-xl font-bold text-matrix-primary mb-6 flex items-center gap-2" data-id="element-110">
              <Check className="w-6 h-6" data-id="element-111" /> Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-112">
              {["Sientes que 'te vas' de tu vida en el teléfono", 'Quieres espiritualidad aterrizada (presencia con estructura)', 'Estás listo para 30 días de regreso real, no perfecto'].map((item, i) => <li key={i} className="flex items-start gap-3 text-matrix-text/90" data-id="element-113">
                  <div className="w-1.5 h-1.5 rounded-full bg-matrix-primary mt-2.5 shrink-0" data-id="element-114" />
                  <span data-id="element-115">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-116">
            <h3 className="text-xl font-bold text-matrix-red mb-6 flex items-center gap-2" data-id="element-117">
              <X className="w-6 h-6" data-id="element-118" /> No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-119">
              {['Buscas una solución mágica sin tocar tus hábitos', "Quieres un 'detox' extremo de moda para presumir", 'No estás dispuesto a proteger ni un solo umbral'].map((item, i) => <li key={i} className="flex items-start gap-3 text-matrix-muted" data-id="element-120">
                  <div className="w-1.5 h-1.5 rounded-full bg-matrix-red mt-2.5 shrink-0" data-id="element-121" />
                  <span data-id="element-122">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}